// extracted by mini-css-extract-plugin
module.exports = {"root":"DetailsForm_root__32Gsg","slider":"DetailsForm_slider__xoagl"};